import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatusEnum } from '../../../enum/status/status.enum';
import { VoipInternalModel } from '../../../models/entity/voip-internal.model';
import { VoipEntity } from '../../../models/entity/voip.model';
import { AlertifyService } from '../../../services/core/alertify.service';
import { VoipInternalService } from '../../../services/voip/voip-internal.service';
import { VoipService } from '../../../services/voip/voip.service';
import { VoipCallTypeEnumValues } from '../../../enum/voip/voip-call-type.enum';

@Component({
  selector: 'app-voip-internal-add-update',
  templateUrl: './voip-internal-add-update.component.html',
  styleUrls: ['./voip-internal-add-update.component.css']
})
export class VoipInternalAddUpdateComponent implements OnInit {

  @Input() data: VoipInternalModel;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  isActive: boolean = true;
  fieldTextType: boolean;
  voips: VoipEntity[] = [];
  voipCallTypeEnumValues = VoipCallTypeEnumValues;
  constructor(
    private voipInternalService: VoipInternalService,
    private voipService: VoipService,
    private translate: TranslateService,
    private alertifyService: AlertifyService) { }

  async ngOnInit(): Promise<void> {
    await this.getVoips();
    if (this.data) {
      if (this.data.status != StatusEnum.ACTIVE) {
        this.isActive = false;
      }
    }
    else {
      this.data = new VoipInternalModel();

      if (this.voips.length == 1)
        this.data.voipId = this.voips[0].id;
    }
  }

  async getVoips() {
    try {

      const res = await this.voipService.getVoips().toPromise();
      this.voips = res;

    }
    catch (err) {
      this.alertifyService.error(err);
    }
  }
  //güncelle veya yeni kayıt ekle
  save() {
    if (!this.validateSave())
      return;


    //Yeni kayıt ise
    if (!this.data.id) {
      this.add();
    }
    //Var olan kaydı güncelle
    else {
      this.update();
    }
  }

  //kontroller
  validateSave() {
    //Status alanı değerini güncelle
    if (this.isActive) this.data.status = StatusEnum.ACTIVE;
    else if (this.data.status == StatusEnum.ACTIVE)
      this.data.status = StatusEnum.PASSIVE;

    return true;
  }

  // yeni kayıt ekle
  add() {
    this.voipInternalService.addVoipInternal(this.data).subscribe(
      (res) => {
        this.data = res;
        this.alertifyService.success(this.translate.instant('message.info.saved'));
        this.passEntry.emit(this.data);

      },
      (err) => {
        this.alertifyService.error(err);
      }
    );
  }

  // güncelle
  update() {
    this.voipInternalService
      .updateVoipInternal(this.data.id, this.data)
      .subscribe(
        (res) => {
          this.data = res;
          this.alertifyService.success(this.translate.instant('message.info.updated'));
          this.passEntry.emit(this.data);
        },
        (err) => {
          this.alertifyService.error(err);
        }
      );
  }

  close() {
    this.passEntry.emit();
  }
}
